const initialState = {
	pathname: null,
	rich_data: false,
	show_description: false,
	current_video: null
};

const statusReducer = (state=initialState, action) => {
	switch (action.type) {
		case 'PAGE_CHANGE':
			return { ...state, pathname: action.pathname };

		case 'SNIFF_AGENT':
			{
				switch( action.payload.os ) {
					case 'iOS':
					case 'Android':
						return { ...state, rich_data: false }
					default:
						break;
				}

				if ( typeof action.payload.device.type === 'undefined' ) {
					return { ...state, rich_data: true }
				}

				return { ...state, rich_data: false };
			}

		case 'SHOW_SITE_INTRO':
			return { ...state, show_description: true };

		case 'MENU_ENTER':
		case 'MENU_SET_ACTIVE':
		case 'HIDE_SITE_INTRO':
			return { ...state, show_description: false };

		case 'VIDEO_PLAY':
			return { ...state, current_video: action.payload.video };

		default:
			return state;
	}
}

export default statusReducer;


// WEBPACK FOOTER //
// ./src/reducers/status.jsx